module.exports = __webpack_public_path__ + "static/img/焊接机器人自动化线.a2bef972.png";